export const newsloader = (() => {
    let _page = 1;
    let _reqNotBusy = true;
    let _fetchMoreNewsButton = null;
    const _maxItems = 10;

    document.addEventListener('DOMContentLoaded', function () {

        _fetchMoreNewsButton = document.querySelector("#js-fetch-more-news");
        if (_fetchMoreNewsButton) {
            _fetchMoreNewsButton.addEventListener('click', function (event) {
                event.preventDefault();
                fetchMoreNews();
            });
        }
    });

    document.addEventListener('DOMContentLoaded', function () {

        _fetchMoreNewsButton = document.querySelector("#js-fetch-more-guide-news");
        if (_fetchMoreNewsButton) {
            _fetchMoreNewsButton.addEventListener('click', function (event) {
                event.preventDefault();
                const hiddenItems = document.querySelectorAll(".newsPageList li.hidden");

                // Loop through the first 6 elements (or fewer if there are less than 6)
                for (let i = 0; i < Math.min(hiddenItems.length, 6); i++) {
                    hiddenItems[i].classList.remove("hidden");
                }

                const remainingItems = document.querySelectorAll(".newsPageList li.hidden").length
                if (remainingItems == 0) {
                    document.querySelector("#js-fetch-more-guide-news").classList.replace("btn","hidden");
                }
            });
        }
    });

    function fetchMoreNews() {
        if (_reqNotBusy) {
            _page++;
            _reqNotBusy = false;
            fetch(window.location.pathname + '?sida=' + _page)
                .then(function (response) {
                    return response.text();
                })
                .then(htmlString => {
                    addNextListToCurrent(htmlString);
                })
                .catch(error => {
                    console.error('There was an error with the fetch operation:', error);
                }).finally(() => {
                    _reqNotBusy = true;
                });
        }
    }

    function addNextListToCurrent(htmlString) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        const newslist = doc.querySelectorAll('#js-news-list li');
        const targetList = document.querySelector('#js-news-list');

        let itemCount = 0;
        newslist.forEach(item => {
            targetList.appendChild(item.cloneNode(true));
            itemCount++;
        });

        const newsCount = document.querySelectorAll('#js-news-list li').length;
        document.querySelector('#js-filter-count-items').innerHTML = newsCount;

        if (itemCount < _maxItems) {
            _fetchMoreNewsButton.classList.add('hidden');
        }
    }

})();